import React, {
	useEffect,
	useState,
	useMemo
} from 'react'

import {
	useDispatch,
	useSelector
} from 'react-redux'

import Button from 'react-bootstrap/Button'
import Table from "react-bootstrap/Table"
import Spinner from 'react-bootstrap/Spinner'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import "react-datepicker/dist/react-datepicker.css"
import { Link } from 'react-router-dom';
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch'
import Card from "react-bootstrap/Card"
import OverlayTrigger from "react-bootstrap/OverlayTrigger"
import Tooltip from "react-bootstrap/Tooltip"
import { useHistory } from 'react-router-dom';
import Select from "react-select"
import Tabs from "react-bootstrap/Tabs"
import Tab from "react-bootstrap/Tab"
import DiscussResourceButton from '../DiscussResourceButton/DiscussResourceButton'
import {
	getAllCustomForms,
	selectAllCustomForms,
	createForm,
	deleteForm,
	deleteAllForms,
	updateFormTitle,
	getAllAssignedForms,
	addFormToGymLibrary,
	copyForm,
	addFormToMultipleClients,
	getClientsForAssigning,
	removeFormFromClient,
	removeFormMultipleClients,
} from "../../state/customFormsSlice"
import classes from "./customForms.module.css"
import {
	getAllClients,
	selectTrainerParam
} from '../users/usersSlice.js'
import { capitalize,envAwarePost } from '../../util/util'
import useCurrentUser from '../../hooks/useCurrentUser'
import { useMapClientsToOptions } from '../../hooks/useMapClientsToOptions';

const mapTagsToOptions = tags => tags?.map(t => ({
	value: t.id,
	label: t.name,
	id: t.id
}))


function CustomForms() {
	const urlParams = new URLSearchParams(window.location.search)
	const [filterId,setFilterId] = useState(parseInt(urlParams.get('form_id')))
	let dispatch = useDispatch();
	let history = useHistory();
	const formList = useSelector(selectAllCustomForms)
	const owners = useMemo(() => Array.from(new Set(formList.map(f => f.owner_type))))
	const [ownerFilter, setOwnerFilter] = useState('all')
	const [createFormShow, setCreateFormShow] = useState(false);
	const [formTitle, setFormTitle] = useState("");
	const [newFormTitle, setNewFormTitle] = useState("");

	const [copyFormShow, setCopyFormShow] = useState(false);
	const [newCopyFormTitle, setNewCopyFormTitle] = useState("");

	const [newFormLoad, setNewFormLoad] = useState(false);
	const [editFormShow, setEditFormShow] = useState(false);
	const [editFormId, setEditFormId] = useState("");
	const [editDefault,setEditDefault] = useState(false)
	const [errorModalShow, setErrorModalShow] = useState(false);
	const [isAddToGymLoading, setIsAddToGymLoading] = useState(false);
	const [showAssignForm, setShowAssignForm] = useState(false);
	const [showEmailModal, setShowEmailModal] = useState(false);
	const user = useCurrentUser()

	const isTrainer = user.account_type === "trainer";
	const isGym = user.account_type === "gym";
	const isClient = user.account_type === "client";
	const isTrainerOrGym = isTrainer || isGym
	const isPartOfGym = user.gym_id != 0
	const isSharedClient = isClient && Number(user.gym_id) === Number(user.trainer_data.trainer_id)
	const userId = user.user_id_number
	const [clientsToAssign, setClientsToAssign] = useState([])

	const [isClientListLoading, setIsClientListLoading] = useState(false)
	const trainerParam = useSelector(selectTrainerParam)
	const [loadingAssign, setLoadingAssign] = useState(false);
	const [allClientsActive, setAllClientsActive] = useState(false);
	const [futureClientsActive, setFutureClientsActive] = useState(false);

	const [tempClientsToAssign, setTempClientsToAssign] = useState([]);
	//gets clientlist from store then converts to array and sorts by name
	const unassignedClientList = useSelector(state => state.customForms.unassignedClients)
	const assignedClientList = useSelector(state => state.customForms.assignedClients)

	//takes clientlist and returns an array of select objects
	let unassignedClientsOptions = useMapClientsToOptions(unassignedClientList);
	let assignedClientsOptions = useMapClientsToOptions(assignedClientList);
	const allClientsOptions = useMapClientsToOptions([
		...unassignedClientList,
		...assignedClientList
	].sort((a,b)=>a.user_name.toLowerCase()<b.user_name.toLowerCase()?-1:1))

	const [tags,setTags] = useState([])
	useEffect(() => {
		envAwarePost(
			'api/users/api/',
			{ action: 'getAllTags' }
		).then(res => {
			setTags(res.data)
		})
	}, [showAssignForm])

	const [assignByTag,setAssignByTag] = useState(false)
	const tagsOptions = mapTagsToOptions(tags)

	const [tabKey, setTabKey] = useState('new_assign');
	const [formRemoveLoading, setFormRemoveLoading] = useState("");


	const statusDispatch = useApiStatusDispatch();

	useEffect(() => {
		if (isTrainerOrGym) {
			dispatch(getAllCustomForms({ action: "getAllCustomForms" }))
		}
		if (isClient) {
			dispatch(getAllAssignedForms({ action: "getAllAssignedForms" }))

		}
	}, [isClient, isTrainerOrGym])


	function createNewForm() {
		let payload = {
			form_title: formTitle,
			action: "createForm"
		}
		setNewFormLoad(true)
		statusDispatch(createForm(payload), "form", "create").then(
			res => {
				let formId = res?.payload?.data?.form_id
				if (formId) {
					history.push(`/formEditor?formId=${formId}&clientId=${isClient ? userId : "edit"}&${trainerParam}`)
				}
				clearForm();
				setNewFormLoad(false)
				setCreateFormShow(false);
				if (res.payload.success === "2") {
					if (res.payload.message) {
						setErrorModalShow(true);
					}
				}
			}
		)
	}

	function handleAddFormToGymLibrary() {
		if (window.confirm("Are you sure? This will transfer form ownership, including the ability to create/edit questions, to your gym.")) {
			setIsAddToGymLoading(true);
			statusDispatch(addFormToGymLibrary({ form_id: editFormId }), "form", "add")
				.then(res => {
					setIsAddToGymLoading(false);
					setEditFormShow(false);
					setFormTitle("")
					if (isTrainerOrGym) {
						dispatch(getAllCustomForms({ action: "getAllCustomForms" }))
					}
				})
		}
	}

	function handleDeleteForm(form_id) {
		let payload = {
			form_id,
			action: "deleteForm"
		}
		if (window.confirm("Are you sure you want to delete this form? All of the form questions and client answer data will be permanently deleted.")) {
			statusDispatch(deleteForm(payload), "form", "delete")
		}
	}

	function handleCopyForm() {
		let payload = {
			form_id: editFormId,
			form_title: newCopyFormTitle,
			action: "copyForm"
		}
		setNewFormLoad(true)
		statusDispatch(copyForm(payload), "form", "duplicate").then(
			res => {
				setNewFormLoad(false);
				setCopyFormShow(false);
				clearForm();
				if (res.payload.success === "2") {
					if (res.payload.message) {
						setErrorModalShow(true);
					}
				}
			}
		)
	}

	//add form assignment
	function handleAssignClients() {
		setLoadingAssign(true)
		let client_ids = (allClientsActive) ?
			//send all client_ids
			unassignedClientsOptions.map(obj => obj.value) :
			//send only selected client_ids
			clientsToAssign.map(obj => obj.value);

		let assign_future = futureClientsActive ? "1" : "0"
		statusDispatch(addFormToMultipleClients(
			{
				assign_by_tag:Number(assignByTag),
				tag_ids:clientsToAssign.map(({value})=>value),
				client_ids,
				form_id: editFormId,
				assign_future,
			}), "Form assignment", "update")
			.then(res => {
				setLoadingAssign(false);
				setShowAssignForm(false);
				clearForm();
			}).then(res => {
				dispatch(getAllCustomForms({ action: "getAllCustomForms" }));
			})
	}

	function handleEmailForm() {
		setLoadingAssign(true)
		let client_ids = (allClientsActive) ?
			//send all client_ids
			allClientsOptions.map(obj => obj.value) :
			//send only selected client_ids
			clientsToAssign.map(obj => obj.value);

		envAwarePost('/api/customForms/',{
			action:'emailFormToClients',
			client_ids:allClientsActive?'all':client_ids,
			form_id:editFormId
		}).then(()=>{
			setLoadingAssign(false);
			setShowEmailModal(false);
			clearForm();
		})
	}

	// remove form assignment
	function handleRemoveAssign(client) {
		//remove form assignment for all clients
		if (client === "all") {
			setFormRemoveLoading("all")
			let client_ids = assignedClientList.map(obj => obj.user_id_number)
			dispatch(removeFormMultipleClients({
				action: "removeFormMultipleClients",
				client_ids: client_ids,
				form_id: editFormId
			})).then(res => {
				dispatch(getClientsForAssigning({ form_id: editFormId }))
					.then(res => {
						setFormRemoveLoading("")
					})
			})

			return;
		}
		// remove form assignment for specific client
		setFormRemoveLoading(client.user_id_number)
		dispatch(removeFormFromClient({
			action: "removeFormFromClient",
			client_id: client.user_id_number,
			form_id: editFormId
		}))
			.then(res => {
				dispatch(getClientsForAssigning({ form_id: editFormId }))
					.then(res => {
						setFormRemoveLoading("")
					})
			})
	}

	function handleUpdateForm() {
		let payload = {
			form_id: editFormId,
			form_title: newFormTitle,
			action: "updateFormTitle"
		}
		setNewFormLoad(true)
		statusDispatch(updateFormTitle(payload), "form", "update").then(
			res => {
				setNewFormLoad(false);
				setEditFormShow(false);
				clearForm();
				dispatch(getAllCustomForms({ action: "getAllCustomForms" }))
			}
		)
	}

	function handleAssignOpen(e, form) {
		e.currentTarget.blur();
		setShowAssignForm(true);

		setIsClientListLoading(true)


		dispatch(getClientsForAssigning({ form_id: form.form_id })).then(
			res => {
				setIsClientListLoading(false)
			})



		setFormTitle(form.form_title)
		setEditFormId(form.form_id);
		setFutureClientsActive(form.assign_future == 1)
	}


	function handleEmailOpen(e, form) {
		e.currentTarget.blur();
		setShowEmailModal(true);

		setIsClientListLoading(true)


		dispatch(getClientsForAssigning({ form_id: form.form_id })).then(
			res => {
				setIsClientListLoading(false)
			})



		setFormTitle(form.form_title)
		setEditFormId(form.form_id);
		setFutureClientsActive(form.assign_future == 1)
	}

	function handleCancelForm() {
		setEditFormShow(false);
		setCreateFormShow(false);
		clearForm();
	}

	function handleDeleteAllForms() {
		if (window.confirm("Are you sure you want to delete ALL forms?")) {
			statusDispatch(deleteAllForms(), "all forms", "deleted")
			dispatch(getAllCustomForms({ action: "getAllCustomForms" }))
		}
	}


	function clearForm() {
		setFormTitle("")
		setNewFormTitle("")
		setEditFormId("")
		setNewCopyFormTitle("")
		setClientsToAssign([]);
		setTempClientsToAssign([]);
		setAllClientsActive(false);
		setFutureClientsActive(false);
	}


	return (
		<div 
			className={[classes.MainBody,'pt-2 px-2 px-md-3'].join(' ')} 
			style={{ background: 'white', paddingBottom: '25px' }} 
			id="containerDiv"
		>
			<strong className="d-block mb-1">
				{isTrainerOrGym && <span> Custom </span>}Forms
			</strong>
			<div className="d-flex align-items-center">
				{/* Only gym trianers/non-shared clients should see this select*/}
				{(isPartOfGym && !isGym && !isSharedClient) &&
					<Form.Control
						onChange={e => { setOwnerFilter(e.target.value) }}
						value={ownerFilter}
						as="select"
					>
						<option value="all">All Forms</option>
						{owners.map(o => (
							<option value={o}>
								{`My ${user.account_type === o ? '' : `${capitalize(o)}'s`} Forms`}
							</option>
						))}
					</Form.Control>
				}
				{isTrainerOrGym &&
					<div className="">
						<Button
							onClick={() => { setCreateFormShow(true); }}
							variant="outline-success"
							style={{ minWidth: "160px" }}
							className="ml-2"
						>
							Create New Form
						</Button>
					</div>
				}
			</div>
			{Boolean(filterId)&&
				<div className="mb-2">
					Viewing filtered list: 
					<Button 
						onClick={()=>{ 
							setFilterId(false)
							history.replace('/customForms/')
						}}
						variant="outline-danger" 
						className="ml-2"
						size="sm"
					>
						Clear Filters
					</Button>
				</div>
			}
			{/* <Card size="lg"> */}
			{/* <Card.Body> */}
			<>
				<Table bordered hover size="sm" className="mt-2">
					<thead>
						<tr>
							<th>
								Form List
								{(isTrainerOrGym && (ownerFilter === user.account_type || !isPartOfGym)) && <Button
									variant="outline-danger"
									className={classes.DeleteAllBtn}
									onClick={() => {
										handleDeleteAllForms();
									}}
								>
									<i
										class="fa fa-trash"
										aria-hidden="true"
										style={{ paddingRight: 10 }}
									></i>
									All
								</Button>}
							</th>
						</tr>
					</thead>
					<tbody>
						{formList.length > 0 &&
							formList.filter(f=>!Boolean(filterId)||f.form_id===filterId).filter(f => ownerFilter === 'all' || f.owner_type === ownerFilter).map(form => {
								return (
									<tr key={form.form_id}>
										<td > <div className="mt-2 d-flex justify-content-between flex-wrap" key={form.form_id}>

											<Link to={`/formEditor?formId=${form.form_id}&clientId=${isClient ? userId : "edit"}&${trainerParam}`}> <Button variant={"link"} > {form.form_title} </Button></Link>

											{isTrainerOrGym &&
												<div className="d-flex justify-content-center align-items-center" >
													<div className="d-flex">
														<OverlayTrigger placement="top" overlay={
															<Tooltip>
																Assign To Clients
															</Tooltip>
														}>
															<Button size="sm"
																className="mr-2"
																onClick={(e) => {
																	handleAssignOpen(e, form)
																}}
																variant="outline-success"
															>
																Assign
															</Button>

														</OverlayTrigger>
													</div>
													<OverlayTrigger overlay={
														<Tooltip>Discuss this custom form in the chat</Tooltip>
													}>
														<span>
															<DiscussResourceButton
																className="btn btn-sm btn-outline-info m-1"
																name={form.form_title}
																id={form.form_id}
																type="custom_form"
															>
																<i className="fa fa-comments"/>
															</DiscussResourceButton>
														</span>
													</OverlayTrigger>
													{(form.owner_type === user.account_type) &&
														<>
															<OverlayTrigger placement="top" overlay={
																<Tooltip>
																	Duplicate Form
																</Tooltip>
															}>
																<Button size="sm"
																	className=""
																	onClick={(e) => {
																		e.currentTarget.blur();
																		setCopyFormShow(true);
																		setFormTitle(form.form_title)
																		setEditFormId(form.form_id);
																		setEditDefault(parseInt(form.user_id_number)===999999)
																	}}
																	variant="outline-primary"
																>
																	<i className="fas fa-copy w-100 " />
																</Button>
															</OverlayTrigger>
															<OverlayTrigger placement="top" overlay={
																<Tooltip>
																	Email form to clients
																</Tooltip>
															}>
																<Button size="sm"
																	className="ml-1"
																	onClick={(e) => {
																		handleEmailOpen(e, form)
																	}}
																	variant="outline-dark"
																>
																	<i className="fas fa-at w-100 " />
																</Button>
															</OverlayTrigger>
															
															<OverlayTrigger placement="top" overlay={
																<Tooltip >
																	{isPartOfGym && !isGym && !isSharedClient ? "Options" : "Rename"}
																</Tooltip>
															}>
																<Button variant="outline-secondary" size="sm" className="d-block ml-1"
																	onClick={(e) => {
																		e.currentTarget.blur();
																		setEditFormId(form.form_id);
																		setFormTitle(form.form_title);
																		setNewFormTitle(form.form_title);
																		setEditFormShow(true)
																	}}>
																	<i className="fas fa-cog w-100">  </i>
																</Button>
															</OverlayTrigger>

															<Button
																size="sm"
																variant="outline-danger"
																className="d-block w-100 ml-1"
																onClick={() => handleDeleteForm(form.form_id)}
															>
																X
															</Button>
														</>}
												</div>}
											{isClient&&
												<OverlayTrigger overlay={
													<Tooltip>Discuss this custom form in the chat</Tooltip>
												}>
													<span>
														<DiscussResourceButton
															className="btn btn-sm btn-outline-info m-1"
															name={form.form_title}
															id={form.form_id}
															type="custom_form"
														>
															<i className="fa fa-comments"/>
														</DiscussResourceButton>
													</span>
												</OverlayTrigger>
											}
										</div></td>
									</tr>
								)
							})}
					</tbody>
				</Table>
			</>
			{/* </Card.Body> */}
			{/* </Card> */}

			{/* Add modal */}
			<Modal
				show={createFormShow}
				onHide={() => { setCreateFormShow(false); setFormTitle("") }}
			>
				<Modal.Header>
					<Modal.Title id="contained-modal-title-vcenter">
						Create new form
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group>
						<Form.Label> Form Title  </Form.Label>
						<Form.Control type="text" value={formTitle} onChange={(e) => setFormTitle(e.target.value)} />
					</Form.Group>

					{newFormLoad ?
						<Button className="mt-2" variant="success" style={{ float: "right" }} onClick={createNewForm}>
							<Spinner animation="border" role="status" size={"sm"}>
								<span className="sr-only">Loading...</span>
							</Spinner>
						</Button> :
						<Button className="mt-2" variant="success" style={{ float: "right" }} onClick={createNewForm}>
							Save
						</Button>
					}
					<Button className="mt-2 mr-2 float-right" variant="danger"
						onClick={handleCancelForm}>
						Cancel
					</Button>
				</Modal.Body>
			</Modal>

			{/* copy form modal */}
			<Modal
				show={copyFormShow}
				onHide={() => { setCopyFormShow(false); clearForm() }}
			>
				<Modal.Header>
					<Modal.Title className="h5" id="contained-modal-title-vcenter">
						Duplicate Form:  <span style={{ fontWeight: "normal" }}> "{formTitle}"</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group>
						<Form.Label> New Form Title  </Form.Label>
						<Form.Control
							type="text" value={newCopyFormTitle}
							placeholder="enter new title"
							onChange={e => setNewCopyFormTitle(e.target.value)} />
					</Form.Group>

					<Button className="mt-2" style={{ float: "right" }} onClick={handleCopyForm}>
						{newFormLoad ?
							<Spinner animation="border" role="status" size={"sm"}>
								<span className="sr-only">Loading...</span>
							</Spinner> : <span> Save </span>}
					</Button>
					<Button className="mt-2 mr-2 float-right" variant="danger"
						onClick={() => { setCopyFormShow(false); clearForm() }}>
						Cancel
					</Button>
				</Modal.Body>
			</Modal>



			{/* edit modal */}
			<Modal
				show={editFormShow}
				onHide={() => { setEditFormShow(false); setFormTitle("") }}
			>
				<Modal.Header>
					<Modal.Title className="h5" id="contained-modal-title-vcenter">
						Edit "{formTitle}"
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group>
						<Form.Label> Edit Title  </Form.Label>
						<Form.Control type="text" value={newFormTitle} placeholder="enter new title" onChange={(e) => setNewFormTitle(e.target.value)} />
					</Form.Group>
					{/* only gym trainers should see this */}
					{isPartOfGym && !isGym && !isSharedClient && <Form.Group>
						<Form.Label> Gym Library  </Form.Label>
						<br />
						<Button size="sm"
							className="mr-1 mb-2"
							variant="outline-success"
							onClick={handleAddFormToGymLibrary}>
							{isAddToGymLoading ? <Spinner animation="border" role="status" size={"sm"}>
								<span className="sr-only">Loading...</span>
							</Spinner> : "Transfer Form to Gym Library"}
						</Button>
						<OverlayTrigger
							placement={"top"}
							overlay={
								<Tooltip id={`tooltip-top`}>
									This will transfer form ownership,
									including the ability to create/edit questions,
									to your gym.
								</Tooltip>
							}
						>
							<i
								className="fas fa-info-circle"
								style={{ color: "#525F7F" }}
							></i>
						</OverlayTrigger>

					</Form.Group>}


					<Button className="mt-2" style={{ float: "right" }} onClick={handleUpdateForm}>
						{newFormLoad ?
							<Spinner animation="border" role="status" size={"sm"}>
								<span className="sr-only">Loading...</span>
							</Spinner> : <span> Save </span>}
					</Button>
					<Button className="mt-2 mr-2 float-right" variant="danger"
						onClick={handleCancelForm}>
						Cancel
					</Button>
				</Modal.Body>
			</Modal>

			<Modal show={errorModalShow} onHide={() => setErrorModalShow(false)} >
				<Modal.Header closeButton>
					<Modal.Title>Account Limit</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p className="mt-2"> Sorry you have reached your account limit. Upgrade your plan to add more forms </p>
				</Modal.Body>

				<Modal.Footer>
					<Button variant="primary" onClick={() => setErrorModalShow(false)}>Close</Button>
				</Modal.Footer>
			</Modal>

			{/* assign form modal */}
			<Modal
				show={showAssignForm}
				onHide={() => { setShowAssignForm(false); clearForm() }}
			>
				<Modal.Header closeButton>
					<Modal.Title className="h5" id="contained-modal-title-vcenter">
						Form Assignments:  <span style={{ fontWeight: "normal" }}> "{formTitle}"</span>
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Tabs
						activeKey={tabKey}
						onSelect={key => setTabKey(key)}
						id="assign_tab"
						className="mb-3">
						<Tab eventKey="new_assign" title="New">
							<Form.Group>
								<Form.Label>
									Assign To Client(s) <br />
									<small> <i className="fa fa-info-circle "> </i> <i>Only unassigned clients displayed </i> </small>
								</Form.Label>
								<div className="d-flex justify-content-between align-items-center">
									<Select
										className={assignByTag?'w-100':"w-75"}
										isDisabled={allClientsActive}
										value={clientsToAssign}
										isMulti={true}
										onChange={(arr) => {
											setClientsToAssign(arr)
										}}
										noOptionsMessage={() => (
											isClientListLoading ?
												'Loading clients' :
												'All Clients Assigned')}
										options={
											assignByTag
											? tagsOptions
											: unassignedClientsOptions
										}
									/>
									{!assignByTag&&
										<Form.Check
											type={"checkbox"}
											label={`All Clients`}
											id={`allCurrentClients`}
											checked={allClientsActive}
											onClick={(e) => {
												if (!allClientsActive) {
													// remove clients from select list and save in temp storage
													setTempClientsToAssign(clientsToAssign, setClientsToAssign([]))
												} else {
													// readd removed clients
													setClientsToAssign(tempClientsToAssign, setTempClientsToAssign([]))
												}
												setAllClientsActive(prev => !prev)
												e.target.blur();
											}}
										/>
									}


								</div>
								<div>
									<Form.Check 
										className="mt-1"
										onChange={e=>{
											setAssignByTag(e.target.checked)
										}}
										checked={assignByTag}
										id="copy-workout-by-tag-check"
										label="Assign to clients by tag"
									/>
								</div>
							</Form.Group>
							<div>
								{<Form.Check
									type={"checkbox"}
									label={`Automatically assign future clients`}

									id="allFutureClients"
									checked={futureClientsActive}
									onClick={(e) => {
										setFutureClientsActive(prev => !prev)
										e.target.blur();
									}}
								/>}
							</div>
						</Tab>
						<Tab eventKey="existing_assign" title="Existing Assignments">
							<div className="mt-4" style={{ maxHeight: "400px", overflow: "auto" }}>
								{isClientListLoading ?
									<Spinner animation="border" role="status" variant="primary">
										<span className="sr-only">Loading...</span>
									</Spinner> :
									assignedClientList?.length < 1 ?
										<div> No Clients Assigned </div> :
										<div>
											<div
												style={{ borderBottom: "1px solid black" }}
												className="d-flex justify-content-between pb-3">
												<div className="d-flex align-items-center"> <b> Assigned Clients </b> </div>

												<Button
													className=" d-block"
													size="sm"
													style={{ marginLeft: "auto" }}
													disabled={formRemoveLoading === "all"}
													variant={"outline-danger"}
													onClick={() => handleRemoveAssign("all")}>

													{formRemoveLoading === "all" ? <Spinner animation="border" role="status" size={"sm"}>
														<span className="sr-only">Loading...</span>
													</Spinner> : "Remove All"}
												</Button>
											</div>
											{assignedClientList.map(client => {
												return (
													<div className="mt-3">
														<div className="d-flex justify-content-between">
															<div className="d-flex align-items-center">
																{client.user_name}
																{client.form_complete === "1" ?
																	<div className="d-flex align-items-center text-success ml-1" > (completed)  </div> :
																	<div className="d-flex align-items-center text-danger ml-1" > (incomplete)  </div>}
															</div>
															<Button
																size="sm"
																variant="danger"
																onClick={() => handleRemoveAssign(client)}
																disabled={formRemoveLoading === client.user_id_number}

															>
																{formRemoveLoading === client.user_id_number ?
																	<Spinner animation="border" role="status" size={"sm"}>
																		<span className="sr-only">Loading...</span>
																	</Spinner> :
																	"Remove"}
															</Button>
														</div>
														<hr />
													</div>
												)

											})}
										</div>}
							</div>
						</Tab>

					</Tabs>

				</Modal.Body>
				<Modal.Footer>
					<Button className="mt-2 mr-2 float-right" variant="outline-danger"
						onClick={() => { setShowAssignForm(false); clearForm() }}>
						Close
					</Button>
					{tabKey === "new_assign" && <Button
						variant="success"
						className="mt-2"
						style={{ float: "right" }}
						onClick={handleAssignClients}
						disabled={loadingAssign}>
						{loadingAssign ?
							<Spinner animation="border" role="status" size={"sm"}>
								<span className="sr-only">Loading...</span>
							</Spinner> :
							"Assign"}
					</Button>}

				</Modal.Footer>

			</Modal>

			{/* email form modal */}
			<Modal
				show={showEmailModal}
				onHide={() => { setShowEmailModal(false); clearForm() }}
			>
				<Modal.Header closeButton>
					<Modal.Title className="h5" id="contained-modal-title-vcenter">
						Email "{formTitle}"
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>

					<Form.Label>
						Select Client(s)
					</Form.Label>
					<small className="d-block"> 
						<i className="fa fa-info-circle mr-1"/> 
						<i>Only assigned clients will show in this list </i> 
					</small>
					<div className="d-flex justify-content-between align-items-center">
						<Select
							className="w-75"
							isDisabled={allClientsActive}
							value={clientsToAssign}
							isMulti={true}
							onChange={(arr) => {
								setClientsToAssign(arr)
							}}
							noOptionsMessage={() => 'Loading clients' }
							options={assignedClientsOptions}
						/>
						<Form.Check
							type={"checkbox"}
							label={`All Clients`}
							id={`allCurrentClients`}
							checked={allClientsActive}
							onClick={(e) => {
								if (!allClientsActive) {
									// remove clients from select list and save in temp storage
									setTempClientsToAssign(clientsToAssign, setClientsToAssign([]))
								} else {
									// readd removed clients
									setClientsToAssign(tempClientsToAssign, setTempClientsToAssign([]))
								}
								setAllClientsActive( prev => !prev)
								e.target.blur();
							}}
						/>


					</div>

				</Modal.Body>
				<Modal.Footer>
					<Button 
						className="mt-2 mr-2 float-right" 
						variant="outline-danger"
						onClick={() => { setShowAssignForm(false); clearForm() }}
					>
						Close
					</Button>
					<Button
						variant="success"
						className="mt-2"
						style={{ float: "right" }}
						onClick={handleEmailForm}
						disabled={loadingAssign}>
						{loadingAssign ?
							<Spinner animation="border" role="status" size={"sm"}>
								<span className="sr-only">Loading...</span>
							</Spinner> :
							"Email"}
					</Button>

				</Modal.Footer>

			</Modal>
		</div >
	)
}

export default CustomForms
